export default function getColumnClass(gridSize, windowWidth) {
  if (windowWidth < 576) return 'col-12'; // Mobile: full width
  if (windowWidth < 860) return 'col-6'; // Small: 2 per row
  if (windowWidth < 992) return 'col-md-4'; // Medium: 3 per row
  if (windowWidth < 1200) return 'col-lg-4'; // Large: 3 per row

  const gridClassMap = {
    3: 'col-xl-4',
    4: 'col-xl-3',
    5: 'col-xl-custom-5',
    6: 'col-xxl-custom-6',
  };

  return gridClassMap[gridSize] || 'col-xl-3';
}
